import React, { useEffect, useState } from "react";
import { Modal, Typography, Divider, TextField, Grid, Box, Card, Table, Button, TableRow, TableBody, TableCell, Container, TableContainer } from '@mui/material';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import { useDispatch, useSelector } from "react-redux";
import { CreateCategoryAction, GetCategoryList, ResetCreateCategoryAction, ResetGetCategoryList } from "src/redux/actions/CMSActions";
import Loader from "src/components/Loader";
import { toast } from 'react-toastify';

const Category = () => {
    const dispatch = useDispatch();
    const CategorySelector = useSelector((state) => state.cms?.catgeory_list?.data?.data);
    const CategoryUpdateSelector = useSelector((state) => state.cms?.create_catgeory);
    const loadingSelector = useSelector((state) => state.cms.loading);
    const [open, setOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState()
    const [state, setState] = useState({
        title: "",
        des: "",
        icon: ""
    });

    useEffect(() => {
        dispatch(GetCategoryList());
        return () => dispatch(ResetGetCategoryList())
    }, [dispatch]);

    // const handleCatEdit = (data) => {
    // };

    const stateHandler = (key, value) => {
        state[key] = value;
        setState({ ...state });
    };

    const handleOpen = (text) => {
        setOpen(true);
        setModalTitle(text);
    };

    const handleClose = () => {
        setOpen(false);
    }

    const handleCatSubmit = (e) => {
        e.preventDefault();
        let formData = new FormData();
        formData.append('name', state.title);
        formData.append('description', state.des);
        dispatch(CreateCategoryAction(formData))
        setState({
            title: "",
            des: "",
            icon: ""
        });
    };

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "400px",
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };

    useEffect(() => {
        if (Object.keys(CategoryUpdateSelector).length > 0) {
            if (CategoryUpdateSelector.data.status) {
                toast.success(CategoryUpdateSelector.data.message, { theme: "colored" })
                setOpen(false)
                dispatch(ResetCreateCategoryAction())
                dispatch(GetCategoryList());
            } else {
                toast.error(CategoryUpdateSelector.data.message, { theme: "colored" })
            }
        }
    }, [CategoryUpdateSelector])

    return (
        <Page title="Category Management">
            {loadingSelector ? <Loader /> : null}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography
                        id="modal-modal-title"
                        style={{ marginBottom: 20 }}
                        align={"center"}
                        variant="h6"
                        component="h2"
                    > {modalTitle} </Typography>
                    <Divider />

                    <form autoComplete="off" onSubmit={handleCatSubmit}>
                        <div style={{ marginTop: 25, marginBottom: 15 }}>
                            <Grid md={12}>
                                <TextField
                                    onChange={({ target }) => stateHandler("title", target.value)}
                                    type="text"
                                    label="title"
                                    variant="outlined"
                                    defaultValue={state.title}
                                    fullWidth
                                    required
                                />
                            </Grid>
                        </div>

                        <Grid md={12}>
                            <TextField
                                onChange={({ target }) => stateHandler("des", target.value)}
                                type="text"
                                label="Short Description"
                                variant="outlined"
                                defaultValue={state.des}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Button
                            align={"center"}
                            style={{ marginTop: 20, width: "100%" }}
                            variant="contained"
                            type="submit"
                        >
                            Submit
                        </Button>
                    </form>

                </Box>
            </Modal>

            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Category Management"
                    links={[
                        { name: "Dashboard", href: "/dashboard/app" },
                        { name: "Category Management" },
                    ]}
                    action={
                        <Button
                            variant="contained"
                            // component={RouterLink}
                            onClick={() => handleOpen("Add")}
                        >
                            Add Category
                        </Button>
                    }
                />

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    headLabel={[
                                        { id: 'c_no', label: 'Sr no.', alignRight: false },
                                        { id: 'c_img', label: 'Image', alignRight: false },
                                        { id: 'c_title', label: 'Title', alignRight: false },
                                        { id: 'c_des', label: 'Description', alignRight: false },
                                        // { id: 'c_action', label: 'Actions', alignRight: false }
                                    ]}
                                />
                                <TableBody>
                                    {CategorySelector ?
                                        CategorySelector?.category_list?.map((data, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell component="th" scope="row"> {index + 1}.</TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <img src={data.image} alt={data.name} className="img-fluid" width="50" height="50" style={{ objectFit: "cover" }} />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" style={{ textTransform: "capitalize" }}> {data.name}</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textTransform: "capitalize" }}>
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: data.description }}
                                                        />
                                                    </TableCell>
                                                    {/* <TableCell component="th" scope="row">
                                                        <Button size="small" color="success" onClick={() => handleCatEdit(data)}> Edit </Button>
                                                    </TableCell> */}
                                                </TableRow>
                                            )
                                        })
                                        : ""
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>
                </Card>
            </Container>
        </Page>
    );
};

export default Category;
